var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "50-Income"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5 10.635V9.75C19.5 9.15326 19.2629 8.58097 18.841 8.15901C18.419 7.73705 17.8467 7.5 17.25 7.5H15.75C15.5511 7.5 15.3603 7.57902 15.2197 7.71967C15.079 7.86032 15 8.05109 15 8.25C15 8.44891 15.079 8.63968 15.2197 8.78033C15.3603 8.92098 15.5511 9 15.75 9H17.25C17.4489 9 17.6397 9.07902 17.7803 9.21967C17.921 9.36032 18 9.55109 18 9.75V10.5H5.25C5.05109 10.5 4.86032 10.421 4.71967 10.2803C4.57902 10.1397 4.5 9.94891 4.5 9.75C4.5 9.55109 4.57902 9.36032 4.71967 9.21967C4.86032 9.07902 5.05109 9 5.25 9H6.75C6.94891 9 7.13968 8.92098 7.28033 8.78033C7.42098 8.63968 7.5 8.44891 7.5 8.25C7.5 8.05109 7.42098 7.86032 7.28033 7.71967C7.13968 7.57902 6.94891 7.5 6.75 7.5H5.25C4.65326 7.5 4.08097 7.73705 3.65901 8.15901C3.23705 8.58097 3 9.15326 3 9.75V20.25C3 20.8467 3.23705 21.419 3.65901 21.841C4.08097 22.2629 4.65326 22.5 5.25 22.5H18.75C19.3467 22.5 19.919 22.2629 20.341 21.841C20.7629 21.419 21 20.8467 21 20.25V12.75C20.9987 12.2858 20.8538 11.8333 20.5853 11.4547C20.3168 11.0761 19.9377 10.7897 19.5 10.635ZM18.75 21H5.25C5.05109 21 4.86032 20.921 4.71967 20.7803C4.57902 20.6397 4.5 20.4489 4.5 20.25V11.865C4.74051 11.9523 4.99414 11.998 5.25 12H18.75C18.9489 12 19.1397 12.079 19.2803 12.2197C19.421 12.3603 19.5 12.5511 19.5 12.75V14.25H17.25C16.6533 14.25 16.081 14.4871 15.659 14.909C15.2371 15.331 15 15.9033 15 16.5C15 17.0967 15.2371 17.669 15.659 18.091C16.081 18.5129 16.6533 18.75 17.25 18.75H19.5V20.25C19.5 20.4489 19.421 20.6397 19.2803 20.7803C19.1397 20.921 18.9489 21 18.75 21ZM19.5 15.75V17.25H17.25C17.0511 17.25 16.8603 17.171 16.7197 17.0303C16.579 16.8897 16.5 16.6989 16.5 16.5C16.5 16.3011 16.579 16.1103 16.7197 15.9697C16.8603 15.829 17.0511 15.75 17.25 15.75H19.5Z",
    fill: "url(#paint0_linear_15_1264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.7175 8.7825C10.7872 8.8528 10.8702 8.90859 10.9616 8.94667C11.053 8.98475 11.151 9.00435 11.25 9.00435C11.349 9.00435 11.4471 8.98475 11.5384 8.94667C11.6298 8.90859 11.7128 8.8528 11.7825 8.7825L14.0325 6.5325C14.1737 6.39127 14.2531 6.19973 14.2531 6C14.2531 5.80027 14.1737 5.60873 14.0325 5.4675C13.8913 5.32627 13.6997 5.24693 13.5 5.24693C13.3003 5.24693 13.1087 5.32627 12.9675 5.4675L12 6.4425V2.25C12 2.05109 11.921 1.86032 11.7803 1.71967C11.6397 1.57902 11.4489 1.5 11.25 1.5C11.0511 1.5 10.8603 1.57902 10.7197 1.71967C10.579 1.86032 10.5 2.05109 10.5 2.25V6.4425L9.53252 5.4675C9.46259 5.39757 9.37957 5.3421 9.2882 5.30426C9.19684 5.26641 9.09891 5.24693 9.00002 5.24693C8.90112 5.24693 8.8032 5.26641 8.71183 5.30426C8.62046 5.3421 8.53745 5.39757 8.46752 5.4675C8.39759 5.53743 8.34212 5.62045 8.30427 5.71181C8.26643 5.80318 8.24695 5.90111 8.24695 6C8.24695 6.09889 8.26643 6.19682 8.30427 6.28819C8.34212 6.37955 8.39759 6.46257 8.46752 6.5325L10.7175 8.7825Z",
    fill: "url(#paint1_linear_15_1264)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_1264",
    x1: 21,
    y1: 7.5,
    x2: 0.438809,
    y2: 12.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ADDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15_1264",
    x1: 14.2531,
    y1: 1.5,
    x2: 7.18762,
    y2: 2.60582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ADDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.a242687891e089db5de620df5c69a956.svg";
export { ForwardRef as ReactComponent };